import SubmissionError from '../../../error/SubmissionError'
import http from '../../../utils/http'
import security from '../../../utils/security'
import {
  FACTOREDINVOICE_CREATE_ERROR,
  FACTOREDINVOICE_CREATE_LOADING,
  FACTOREDINVOICE_CREATE_SUCCESS,
  FACTOREDINVOICE_CREATE_VIOLATIONS,
  FACTOREDINVOICE_CREATE_RESET,
} from './mutation-types'

import {
  AGREEMENT_UPDATE_RETRIEVE_SUCCESS
} from './../agreement/mutation-types'

const state = {
  loading: false,
  error: '',
  created: null,
  violations: {},
}

function error (error) {
  return {type: FACTOREDINVOICE_CREATE_ERROR, error}
}

function loading (loading) {
  return {type: FACTOREDINVOICE_CREATE_LOADING, loading}
}

function success (created) {
  return {type: FACTOREDINVOICE_CREATE_SUCCESS, created}
}

function violations (violations) {
  return {type: FACTOREDINVOICE_CREATE_VIOLATIONS, violations}
}

function reset () {
  return {type: FACTOREDINVOICE_CREATE_RESET}
}

function updateAgreementData (retrieved) {
  return {type: 'agreement/update/AGREEMENT_UPDATE_RETRIEVE_SUCCESS', retrieved}
}

const getters = {
  created: state => state.created,
  error: state => state.error,
  loading: state => state.loading,
  violations: state => state.violations,
}

const actions = {
  create ({commit}, values) {
    commit(loading(true))
    commit(violations({}))
    commit(error(null))
    if(typeof values.amount == 'string'){
      values.amount = values.amount.replace(',','.').replace(' ','');
    }
    values.amount = parseFloat(values.amount);
    return http.fetch('/factored_invoices', {method: 'POST', body: JSON.stringify(values)})
      .then(response => {
        commit(loading(false))

        return response.json()
      })
      .then(data => {
        commit(success(data))
        commit(updateAgreementData(data.agreement), {root: true})
      })
      .catch(e => {
        commit(loading(false))
        if (security.handleAuthorizationError(e)) {
          return
        }
        if (e instanceof SubmissionError) {
          commit(violations(e.errors))
          commit(error(e.errors._error))
          return
        }

        commit(error(e.message))
      })
  },
  reset ({commit}) {
    commit(reset())
  }
}

const mutations = {
  [FACTOREDINVOICE_CREATE_ERROR] (state, payload) {
    state.error = payload.error
  },
  [FACTOREDINVOICE_CREATE_LOADING] (state, payload) {
    state.loading = payload.loading
  },
  [FACTOREDINVOICE_CREATE_SUCCESS] (state, payload) {
    state.created = payload.created
  },
  [FACTOREDINVOICE_CREATE_VIOLATIONS] (state, payload) {
    state.violations = payload.violations
  },
  [FACTOREDINVOICE_CREATE_RESET] (state) {
    state.loading = false
    state.error = ''
    state.created = null
    state.violations = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/factoredinvoice/create.js